<template>
    <div class="outbox">
        <!-- 头部 -->
        <div class="hearder_out">
            <div class="hearder">
                <div class="h_l">
                    <img src="../../../static/index/logo.png" style="width: 80px;height: 60px;" />
                    <div>卟简单 更实用</div>
                </div>
                <div class="h_r">
                    <template v-if="isLogin">
                        <el-menu mode="horizontal" text-color="#000" active-text-color="#000">
                            <el-submenu index="2" class="submenu">
                                <template slot="title"><el-avatar size="small" :src="userData.avatar"
                                        style="margin-right: 6px;"></el-avatar></template>
                                <template slot="title">{{ userData.account }}</template>
                                <el-menu-item v-if="ishavaStore" @click="goStore" index="2-1">进入店铺</el-menu-item>
                                <el-menu-item @click="gochooseStore" index="2-2">切换店铺</el-menu-item>
                                <el-menu-item @click="exit()" index="2-5">退出登录</el-menu-item>
                            </el-submenu>
                        </el-menu>
                    </template>

                    <template v-else>
                        <span @click="goIndex">首页</span>
                        <el-dropdown>
                            <span>
                                产品和服务<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu>
                                <el-dropdown-item class="drop-item">
                                    <div style="height: 45px;width: 45px;margin-top: 10px;">
                                        <img src="../../../static/icon1.png" style="width: 100%;height: 100%;" />
                                    </div>
                                    <div class="item-text">
                                        <p style="color: black;font-size: 20px;margin: 0;">全渠道融合版</p>
                                        结合线上线下一体化经营
                                    </div>
                                </el-dropdown-item>
                                <el-dropdown-item class="drop-item">
                                    <div style="height: 45px;width: 45px;margin-top: 10px;">
                                        <img src=".../../../static/icon2.png" style="width: 100%;height: 100%;" />
                                    </div>
                                    <div class="item-text">
                                        <p style="color: black;font-size: 20px;margin: 0;">电商分销版</p>
                                        分销微盟、淘宝等多个平台
                                    </div>
                                </el-dropdown-item>
                                <el-dropdown-item class="drop-item">
                                    <div style="height: 45px;width: 45px;margin-top: 10px;">
                                        <img src="../../../static/icon3.png" style="width: 100%;height: 100%;" />
                                    </div>
                                    <div class="item-text">
                                        <p style="color: black;font-size: 20px;margin: 0;">线下批发版</p>
                                        让门店经营管理更高效
                                    </div>
                                </el-dropdown-item>
                                <el-dropdown-item class="drop-item">
                                    <div style="height: 45px;width: 45px;margin-top: 10px;">
                                        <img src="../../../static/icon4.png" style="width: 100%;height: 100%;" />
                                    </div>
                                    <div class="item-text">
                                        <p style="color: black;font-size: 20px;margin: 0;">微信微商城</p>
                                        以微信作为入口的电商系统
                                    </div>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <span @click="open">合作加盟</span>
                        <span>关于我们</span>
                        <div @click="openLogin('register')" class="resgiter">免费注册</div>
                        <span @click="openLogin('accountLogin')" class="login">登录</span>
                    </template>
                </div>
            </div>
        </div>
        <article class="scroller">

            <div class="content">
                <section>
                    <div class="banner">
                        <div class="banner-text">
                            <div>ABOUT US</div>
                            <div>关于我们</div>
                        </div>
                    </div>
                </section>
                <section>
                    <div class="content-inner">
                        <div class="content-all">
                            <div class="content-title">
                                关于我们
                            </div>
                            <div style="display: flex;">
                                <p class="content-text">
                                    公司成立于2014年，有一支20余人的开发团队，团队核心成员具备丰富的电商经验。超14年电商运营经营拥有丰富的电商运营经验和深刻的市场洞察力。对传统电商、传统渠道销售有深刻的了解，能够准确把握传统电商和传统渠道销售的痛点和需求。多年的技术研发在技术研发方面有着深厚的积累，能够保证系统的稳定性和高效性，为客户打造最具商业价值与用户体验的互联网+产品。
                                </p>
                                <div style="width: 495px;height: 330px;margin-left: 80px;">
                                    <img src="../../../static/index/about.jpg" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <section>
                <!-- 底部 -->
                <div class="footer">
                    <div class="footer_inner">
                        <div class="fl_1">
                            <div class="h_l">
                                <img src="../../../static/index/logo.png" style="width: 60px;height: 40px;" />
                                <div style="color: #cccccc;">
                                    <div style="margin-bottom: 0;font-size: 20px;">卟云系统</div>
                                    <div style="font-size: 8px;margin-left: 10px;">BU YUN XI TONG</div>
                                </div>
                            </div>
                            <div style=" color: #787878;">服务电话：18650291825</div>
                            <div style=" color: #787878;">邮箱：0002@xt1986.com</div>
                            <div style=" color: #787878;">备案：闽ICP备2023007218号-1</div>
                        </div>
                        <div class="fl_2">
                            <div>产品与服务</div>
                            <ul style="list-style: none;">
                                <li >全渠道融合版</li>
                                <li >线下批发版</li>
                                <li >电商分销版</li>
                                <li >微信微商城</li>
                            </ul>
                        </div>
                        <div class="fl_2">
                            <div>热门推荐</div>
                            <ul style="list-style: none;">
                                <li @click="open">建网站</li>
                                <li @click="open">建商城</li>
                                <li @click="open">建小程序</li>
                                <li @click="open">联系我们</li>
                            </ul>
                        </div>
                        <div class="fl_3">
                            <div style="width: 100px;height: 100px;">
                                <img src="../../../static/index/wx.jpg" style="width: 100%; height: 100%;" alt="">
                            </div>
                            <p style="text-align: center;width: 100px;">联系我们</p>
                        </div>
                    </div>
                </div>
            </section>
        </article>
        <div class="login-wrap_out" :class="{ 'login-wrap_out_c': showPop }">
            <div @click.stop class="login-wrap">
                <i @click="showPop = false" class="el-icon-close"></i>
                <h3 class="title">商户平台</h3>
                <el-tabs v-model="status" style="margin-bottom: 10px;" @tab-click="handleClick">
                    <el-tab-pane label="账号登录" name="accountLogin"></el-tab-pane>
                    <el-tab-pane label="手机号登录" name="mobileLogin"></el-tab-pane>
                    <el-tab-pane label="手机号注册" name="register"></el-tab-pane>
                </el-tabs>
                <el-form class="formCls" :class="{ 'formCls_o': showAnimate }" label-position="left" :model="ruleForm"
                    :rules="rules" ref="ruleForm" label-width="0px">
                    <template v-if="status == 'accountLogin'">
                        <el-form-item prop="account">
                            <el-input type="text" v-model="ruleForm.account" auto-complete="off"
                                placeholder="用户名"></el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input type="password" v-model="ruleForm.password" auto-complete="off" placeholder="密码"
                                show-password></el-input>
                        </el-form-item>
                    </template>
                    <template v-else-if="status == 'mobileLogin'">
                        <el-form-item prop="mobile">
                            <el-input v-model="ruleForm.mobile" auto-complete="off" placeholder="手机号"></el-input>
                        </el-form-item>
                        <div style="display: flex;align-items: center;width: 100%;">
                            <el-form-item prop="code" style="flex: 1;">
                                <el-input v-model="ruleForm.code" auto-complete="off" placeholder="验证码"></el-input>
                            </el-form-item>
                            <el-button @click="getyanzhengma" type="primary"
                                style="margin-bottom: 22px;margin-left: 10px;">{{
                                    yanzhengma }}{{ yanzhengma == '获取验证码' ? '' : 's后重试' }}</el-button>
                        </div>
                    </template>
                    <template v-else>
                        <el-form-item prop="mobile">
                            <el-input v-model="ruleForm.mobile" auto-complete="off" placeholder="手机号"></el-input>
                        </el-form-item>
                        <div style="display: flex;align-items: center;width: 100%;">
                            <el-form-item prop="code" style="flex: 1;">
                                <el-input v-model="ruleForm.code" auto-complete="off" placeholder="验证码"></el-input>
                            </el-form-item>
                            <el-button @click="getyanzhengma" type="primary"
                                style="margin-bottom: 22px;margin-left: 10px;">{{
                                    yanzhengma }}{{ yanzhengma == '获取验证码' ? '' : 's后重试' }}</el-button>
                        </div>
                        <el-form-item prop="pwd_r">
                            <el-input v-model="ruleForm.pwd_r" placeholder="密码"></el-input>
                        </el-form-item>
                    </template>
                    <el-form-item style="width:100%;">
                        <el-button type="primary" style="width:100%;" @click="submitForm('ruleForm')"
                            :loading="logining">{{
                                status
                                    ==
                                    'register' ? '注册' : '登录' }}
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
export default {
    name: 'about',
    data() {
        return {
            logining: false,
            showPop: false,
            userData: null,
            isLogin: false,
            ishavaStore: false,
            swiperHeight: '0px',
            bannerList: [],
            status: 'accountLogin',
            showAnimate: false,
            yanzhengma: '获取验证码',
            timer: null,
            ruleForm: {
                account: '',
                password: '',
                mobile: '',
                code: '',
                pwd_r: ''
            },
            rules: {
                account: [{
                    required: true,
                    message: '请输入账号',
                    trigger: 'blur'
                }],
                password: [{
                    required: true,
                    message: '请输入密码',
                    trigger: 'blur'
                }],
                mobile: [{
                    required: true,
                    message: '请输入手机号',
                    trigger: 'blur'
                }],
                code: [{
                    required: true,
                    message: '请输入验证码',
                    trigger: 'blur'
                }],
                pwd_r: [{
                    required: true,
                    message: '请输入密码',
                    trigger: 'blur'
                }],
            },
        }
    },
    // 里面的函数只有调用才会执行
    methods: {
        // 首页
        goIndex() {
            this.$router.push({
                path: '/login'
            })
        },
        // 合作加盟
        open() {
            this.$alert(
                `<div style="text-align: center;">
              <img src="./static/index/wx.jpg" alt="" style="width: 350px;height:350px;">
              <h5>二维码如果过期，请联系客服电话进行咨询并更换</h5>
            </div>`,
                '扫描二维码，即可了解',
                {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                }
            )
        },
        // 获取验证码
        getyanzhengma() {
            if (this.ruleForm.mobile) {
                if (this.yanzhengma == '获取验证码') {
                    this.yanzhengma = 59
                    this.timer = setInterval(() => {
                        if (this.yanzhengma <= 0) {
                            this.yanzhengma = '获取验证码'
                            clearInterval(this.timer)
                        } else {
                            this.yanzhengma = this.yanzhengma - 1
                        }
                    }, 1000)
                    this.$get(this.$api.sendsms, {
                        mobile: this.ruleForm.mobile
                    }).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                        }
                    })
                }
            } else {
                this.$message.error('请输入手机号');
            }
        },
        // 进入店铺
        goStore() {
          let result=JSON.parse(localStorage.getItem('menuList')).filter(item => {
            return item.rule_id==107
          })
          let path=result[0].child[0]
          if(path.type=='menu'){
            path=result[0].child[0].path
          }else{
            path=result[0].child[0].child[0].path
          }
          this.$router.push({
            path: path
          })
        },
        // 切换店铺
        gochooseStore() {
            this.$router.push({
                path: '/chooseStore'
            })
        },
        // 退出登录
        exit() {
            this.$confirm('退出登录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnClickModal: false
            }).then(() => {
                localStorage.setItem('logintoken_shop', '')
                localStorage.setItem('userdata_shop', '')
                localStorage.setItem('ishavaStore', '')
                this.userData = null
                this.isLogin = false
                this.$message({
                    type: 'success',
                    message: '已退出登录!'
                })
            })
        },
        openLogin(type) {
            this.status = type
            this.showPop = true
        },
        handleClick() {
            this.ruleForm.account = ''
            this.ruleForm.password = ''
            this.ruleForm.mobile = ''
            this.ruleForm.code = ''
            this.ruleForm.pwd_r = ''
            clearInterval(this.timer)
            this.yanzhengma = '获取验证码'
            this.$refs['ruleForm'].resetFields();
            this.showAnimate = false
            var that = this
            setTimeout(function () {
                that.showAnimate = true
            }, 500)
        },
        // 账号密码登录
        toPwdLogin() {
            this.$get(this.$api.login, {
                type: 'account',
                account: this.ruleForm.account,
                password: this.ruleForm.password,
            }).then(res => {
                if (res.status == 200) {
                    localStorage.setItem('logintoken_shop', res.data.token.token)
                    localStorage.setItem('userdata_shop', JSON.stringify(res.data.user))
                    this.$store.commit('saveShopData', res.data.shop)
                    this.logining = false
                    this.userData = res.data.user
                    this.isLogin = true
                    this.showPop = false
                    if (res.data.user.last_time_shop_id > 0) {
                        localStorage.setItem('ishavaStore', true)
                        this.ishavaStore = true
                        this.goStore()
                    } else {
                        localStorage.setItem('ishavaStore', false)
                        this.ishavaStore = false
                        this.gochooseStore()
                    }
                }
            })
                .finally(end => {
                    this.logining = false
                })
        },
        // 手机号登录
        toMobileLogin() {
            this.$get(this.$api.login, {
                type: 'mobile',
                mobile: this.ruleForm.mobile,
                code: this.ruleForm.code,
            }).then(res => {
                if (res.status == 200) {
                    localStorage.setItem('logintoken_shop', res.data.token.token)
                    localStorage.setItem('userdata_shop', JSON.stringify(res.data.user))
                    this.$store.commit('saveShopData', res.data.shop)
                    this.logining = false
                    this.userData = res.data.user
                    this.isLogin = true
                    this.showPop = false
                    localStorage.setItem('ishavaStore', false)
                    this.ishavaStore = false
                    this.gochooseStore()
                }
            })
                .finally(end => {
                    this.logining = false
                })
        },
        // 注册
        toregister() {
            this.$post(this.$api.register, {
                mobile: this.ruleForm.mobile,
                code: this.ruleForm.code,
                password: this.ruleForm.pwd_r
            }).then(res => {
                if (res.status == 200) {
                    localStorage.setItem('logintoken_shop', res.data.token.token)
                    localStorage.setItem('userdata_shop', JSON.stringify(res.data.user))
                    // this.$store.commit('saveShopData', res.data.shop)
                    this.logining = false
                    this.userData = res.data.user
                    this.isLogin = true
                    this.showPop = false
                    if (res.data.user.last_time_shop_id > 0) {
                        localStorage.setItem('ishavaStore', true)
                        this.ishavaStore = true
                        this.goStore()
                    } else {
                        localStorage.setItem('ishavaStore', false)
                        this.ishavaStore = false
                        this.gochooseStore()
                    }
                }
            })
                .finally(end => {
                    this.logining = false
                })
        },
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.logining = true
                    if (this.status == 'accountLogin') {
                        this.toPwdLogin()
                    } else if (this.status == 'mobileLogin') {
                        this.toMobileLogin()
                    } else {
                        this.toregister()
                    }
                } else {
                    this.logining = false
                    return false
                }
            })
        },

    }
}
</script>

<style scoped>
.scroller {
    height: 100vh;
    overflow-y: scroll;
    scroll-snap-type: y mandatory;
}

.scroller section {
    scroll-snap-align: center;
}


.content-text {
    min-width: 400px;
    height: 330px;
    color: #606060;
    font-size: 18px;
    letter-spacing: .1em;
}


.content-all {
    width: 50%;
    margin: 0 auto;
    height: 100%;
    padding-top: 85px;
}

.content-inner {
    height: 600px;
    width: 100%;
    background-color: white;
}

.content-title {
    font-size: 40px;
    font-weight: 100;
    color: black;
    text-decoration: underline;
    text-decoration-color: #606060;
}

.banner {
    background-image: url(../../../static/index/banner.jpg);
    background-size: cover;
    background-position: center;
    height: 675px;
    width: 100%;
    position: relative;
}

.banner-text {
    position: absolute;
    top: 190px;
    left: 250px;
    font-size: 35px;
    color: white;
    font-weight: bolder;
}

.item-text {
    font-size: 15px;
    color: #b8b8b8;
    padding-left: 30px;
}

.outbox {
    min-height: 100vh;
    min-width: 1200px;
    background: #F3F3F3;
    position: relative;
}

.hearder_out {
    background: white;
    min-width: 1200px;
}

.hearder {
    margin: 0 auto;
    width: 1200px;
    height: 82px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.h_l {
    display: flex;
    align-items: center;
    font-size: 22px;
    color: #000000;
    ;
    flex-wrap: wrap;
    width: 250px;

}

.h_l img {
    width: 46px;
    height: 46px;
    margin-right: 15px;
}

.h_r {
    display: flex;
    align-items: center;
}

.h_r span {
    font-size: 16px;
    color: #000000;
    margin-right: 55px;
    cursor: pointer;
}

.h_r .login {
    height: 50px;
    width: 90px;
    border: 1px solid #e9e9e9;
    box-shadow: 1px 1px 1px 1px #e9e9e9;
    border-radius: 40px;
    text-align: center;
    line-height: 50px;
}


.h_r .resgiter {
    width: 140px;
    height: 48px;
    text-align: center;
    line-height: 48px;
    background: #FEE610;
    border-radius: 40px;
    font-size: 18px;
    color: #262732;
    cursor: pointer;
    transition: all .3s;
    margin-right: 22px;
}

.h_r div:active {
    transform: scale(.94);
    opacity: .9;
}

.drop-item {
    text-align: left;
    display: flex;
    flex-wrap: wrap;
    color: #000000;
    width: 275px;
    cursor: pointer;
    transition: all .3s;
    border-bottom: 1px solid #e9e9e9;
}

.drop-item:hover {
    color: #858585;
}

.footer {
    background: #212121;
    min-width: 1200px;
    position: relative;
    height: 400px;
}

.footer_inner {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
    display: flex;
    justify-content: space-between;
}

.fl_1 div {
    font-size: 16px;
    color: #FFFFFF;
    line-height: 36px;
}

.fl_1 div:first-child {
    display: flex;
    align-items: center;
    font-size: 24px;
    color: #FFFFFF;
    margin-bottom: 58px;
}

.fl_1 div:first-child img {
    width: 32px;
    height: 32px;
    margin-right: 8px;
}

.fl_2 {
    color: #787878;
    width: 150px;
    text-align: center;
}


.fl_2 li {
    margin-top: 20px;
}

.fl_2 li:hover {
    color: #a0a0a0;
    cursor: pointer;
}

.fl_2 div {
    color: white;
    margin-bottom: 50px;
    width: 180px;
    text-align: center;
}

.fl_3 {
    margin-left: 120px;
    color: white;
    width: 80px;
}

.login-wrap_out {
    width: 0;
    height: 0;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    overflow: hidden;
    transition: all .5s;
}

.login-wrap_out_c {
    width: 100vw;
    height: 100vh;
}

.login-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    padding: 30px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    text-align: left;
    box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1);
    width: 350px;
}

.el-icon-close {
    font-size: 26px;
    position: absolute;
    top: 14px;
    right: 14px;
    cursor: pointer;
}

.el-icon-close:hover {
    cursor: pointer;
    color: #ffaf36;
}

.title {
    margin: 0px auto 40px auto;
    text-align: center;
    color: #505458;
}

>>>.el-carousel__button {
    background: gray;
    height: 4px;
}

>>>.el-carousel__indicator.is-active button {
    background: #ffaf36;
}

>>>.el-button--primary {
    background: #ffaf36;
    border-color: #ffaf36;
}

>>>.el-tabs__item.is-active {
    color: #ffaf36;
}

>>>.el-tabs__active-bar {
    background: #ffaf36;
}

>>>.el-tabs__item:hover {
    color: #ffaf36;
}

>>>.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/views/about/index.vue